import { CommissionDraftContext, Invoice } from '@views/commissionsReferrals/state/commissionsSlice'
import { client } from './client'

const getCommissionsService = async (cocap: string) => {
  const { data } = await client.get('/person/commissions', {
    headers: {
      cocap
    }
  })
  return data
}

const getNextInvoiceSerialService = async (cocap: string) => {
  const { data } = await client.get('/invoices/serial', {
    headers: {
      cocap
    }
  })

  const currentYear = new Date().getFullYear()
  const nextSerialNumber = (Number(data?.serialNumber) || 0) + 1

  return `CC-${currentYear}-${nextSerialNumber}`
}

const reserveInvoiceDraftService = async (cocap: string, invoiceData: Invoice) => {
  const { data } = await client.post('/invoices/draft', invoiceData, {
    headers: {
      cocap
    }
  })
  return data
}

const getCommissionContextService = async (cocap: string): Promise<CommissionDraftContext> => {
  const { data } = await client.get('/invoices/commission-context', {
    headers: { cocap }
  })
  return data
}

const acknowledgeCommissionDraftService = async (
  cocap: string,
  invoiceId: string,
  comparisonFingerprint: string
): Promise<CommissionDraftContext> => {
  const { data } = await client.post(
    `/invoices/draft/${invoiceId}/acknowledge`,
    { decision: 'keep', comparisonFingerprint },
    { headers: { cocap } }
  )
  return data
}

const replaceCommissionDraftService = async (
  cocap: string,
  invoiceId: string,
  comparisonFingerprint: string
): Promise<CommissionDraftContext> => {
  const { data } = await client.post(
    `/invoices/draft/${invoiceId}/replace`,
    { comparisonFingerprint },
    { headers: { cocap } }
  )
  return data
}

const postInvoiceService = async (cocap: string, invoiceData: Invoice) => {
  const { data } = await client.post('/invoices', invoiceData, {
    headers: {
      cocap
    }
  })
  return data
}

const postInvoiceFileService = async (cocap: string, formData: FormData, invoiceId: string) => {
  const { data } = await client.post(`/invoices/file?invoice=${invoiceId}`, formData, {
    headers: {
      cocap,
      'Content-Type': 'multipart/form-data'
    }
  })
  return data
}

export {
  getCommissionsService,
  getCommissionContextService,
  acknowledgeCommissionDraftService,
  replaceCommissionDraftService,
  getNextInvoiceSerialService,
  reserveInvoiceDraftService,
  postInvoiceService,
  postInvoiceFileService
}
